<template>
  <div id="adminCrmAppointments">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">{{ admin }}</li>
      <li class="breadcrumb-item">booking</li>
      <li class="breadcrumb-item active">
        <router-link :to="url">Agenda</router-link>
      </li>
    </ol>
    <div class="container-fluid card-title-admin"> 
        <h1>Agenda</h1>
    </div>
    <div class="container-fluid">
      <div class="card">
        <div class="tab-content">
      
        <ul class="nav nav-tabs" id="myTab" role="tablist">
           <li class="nav-item" role="presentation">
            <button class="nav-link" id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile" type="button" role="tab" aria-controls="profile" aria-selected="false" @click="ontabappointments">Agenda</button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link active" id="home-tab" data-bs-toggle="tab" data-bs-target="#home" type="button" role="tab" aria-controls="home" aria-selected="true" @click="ontabtable">Tabella</button>
          </li>
        </ul>

        <div class="tab-content" id="myTabContent">

           <!-- tab agenda--->
            <div class="tab-pane fade show active" id="appointments" role="tabpanel">
              <FullCalendar ref="calendar" :options="calendarOptions"/> 
            </div>
            <!-- end tab agenda--->

            <!-- tab tabella--->
            <div class="tab-pane fade show" id="tablelist" role="tabpanel">
              <div class="row"> 
            <div class="col-6">
               <div class="row" style="margin-top:10px;">
                      <div class="col-4">
                          <label>Luogo</label>
                           <select2
                            class="form-control"
                            id="place_id_search"
                            name="place_id_search"
                            style="height: 56px!important;"
                            required="required"
                            service="bookingplace"
                            @change="confirmSearchForPlace()"
                          ></select2>
                      </div>
                    <div class="col-4">
                          <label>Servizio</label>
                           <select2
                            class="form-control"
                            id="service_id_search"
                            name="service_id_search"
                            style="height: 56px!important;"
                            required="required"
                            service="bookingservices"
                            @change="confirmSearchForPlace()"
                          ></select2>
                    </div>
                    <div class="col-4">
                        <label>Addetto</label>
                         <select2
                            class="form-control"
                            id="employee_id_search"
                            name="employee_id_search"
                            style="height: 56px!important;"
                            required="required"
                            service="bookingemployee"
                            @change="confirmSearchForPlace()"
                          ></select2>
                    </div>
            </div></div> 

          <div class="col-6">
               <div class="row" style="margin-top:10px;">
                      <div class="col-4">
                          <label>Stato</label>
                           <select2
                            class="form-control"
                            id="id_states_search"
                            name="id_states_search"
                            style="height: 56px!important;"
                            required="required"
                            service="bookingstates"
                            @change="confirmSearchForPlace()"
                          ></select2>
                      </div>
                    <div class="col-3">
                          <label>Dal</label>
                        <date-picker
                        placeholder="Dal"
                        class="classinput"
                        required="required"
                        id="date_from"
                        name="date_from"
                        :config="configDateTime"
                        @change="confirmSearchForPlace()"
                  ></date-picker>
                     <!-- <input type="text" class="form-control" style="height: 56px;" id="date_from" placeholder="Dal" @change="confirmSearchForPlace()"> -->
                    </div>
                    <div class="col-3">
                    <label>Al</label>
                      <date-picker
                        placeholder="Al"
                        class="classinput"
                        required="required"
                        id="date_to"
                        name="date_to"
                        :config="configDateTime"
                        @change="confirmSearchForPlace()"
                  ></date-picker>
                        <!--<input type="text" class="form-control" style="height: 56px;" id="date_to" placeholder="Al" @change="confirmSearchForPlace()">-->
                  </div>

                  <div class="col-2">
                   <button
                          type="button"
                          style="margin-top: 29px;"
                          class="btn btn-success"
                          data-dismiss="modal"
                          @click="confirmSearchForPlace()"
                        ><i class="fa fa-search"></i>&nbsp;
                          Cerca
                        </button></div>
            </div></div></div>  
            <div class="row" style="margin-top:20px;">
              <div class="col-12">
                    <table class="table table-bordered table-hover">
                        <thead>
                          <tr>
                            <th scope="col"></th>
                            <th scope="col">Connessione</th>
                            <th scope="col">Luogo</th>
                            <th scope="col">Servizio</th>
                            <th scope="col">Addetto</th>
                            <th scope="col">Cliente</th>
                            <th scope="col">Descrizione</th>
                            <th scope="col">Data Dal - Al</th>
                            <th scope="col">Ora Inizio - Fine</th>
                            <th scope="col">Stato</th>
                            <th scope="col">Prezzo</th>
                            <th scope="col">Note</th>
                          </tr>
                        </thead>
                   
                        <tbody> 
                          <tr  v-for="ResultDataGetAlls in ResultDataGetAll"
                               v-bind:key="ResultDataGetAlls.id">
                          <td>
                            <button
                              style="margin: 2px;
                                     margin-bottom: -2px;
                                     vertical-align: bottom;
                                     min-width: 50px;"
                              type="button"
                              class="btn btn-light"
                              data-dismiss="modal"
                              @click="onClickDetailPopup(ResultDataGetAlls.id)"
                            ><i class="fa fa-search" style="color:grey"></i>&nbsp;
                        </button></td>
                             <td>
                              <span
                              class="col- col-form-label nopadding"
                              :for="ResultDataGetAlls.connections_id">{{ ResultDataGetAlls.connections_id }}</span></td>
                            <td>
                              <span
                              class="col- col-form-label nopadding"
                              :for="ResultDataGetAlls.place_id">{{ ResultDataGetAlls.place_id }}</span></td>
                            <td> 
                              <span
                              class="col- col-form-label nopadding"
                              :for="ResultDataGetAlls.service_id">{{ ResultDataGetAlls.service_id }}</span></td>
                            <td>
                              <span
                              class="col- col-form-label nopadding"
                              :for="ResultDataGetAlls.employee_id">{{ ResultDataGetAlls.employee_id }}</span></td>
                             <td>
                               <span
                              class="col- col-form-label nopadding"
                              :for="ResultDataGetAlls.user_id">{{ ResultDataGetAlls.user_id }}</span></td>
                              <td>
                               <span
                              class="col- col-form-label nopadding"
                              :for="ResultDataGetAlls.description">{{ ResultDataGetAlls.description }}</span></td>
                            <td>
                              <span
                              class="col- col-form-label nopadding"
                              :for="ResultDataGetAlls.date_from">{{ ResultDataGetAlls.date_from }} - {{ ResultDataGetAlls.date_to }}</span></td>
                            <td><span
                              class="col- col-form-label nopadding"
                              :for="ResultDataGetAlls.start_time">{{ ResultDataGetAlls.start_time }} - {{ ResultDataGetAlls.end_time }}</span></td>
                            <td><span
                              class="col- col-form-label nopadding"
                              :for="ResultDataGetAlls.states_id">{{ ResultDataGetAlls.id_states }}</span></td>
                            <td><span
                              class="col- col-form-label nopadding"
                              :for="ResultDataGetAlls.price">{{ ResultDataGetAlls.price }}</span></td>
                               <td>
                                  <span v-if="ResultDataGetAlls.note == ''"></span>
                                  <span v-else>
                                      <button
                                        type="button"
                                        class="btn btn-link"
                                        data-dismiss="modal"
                                      ><i class="fa fa-comment"></i>&nbsp;
                        </button>  
                                  </span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
              </div></div>
              </div> <!-- end tab tabella--->


   <!--popup detailEvent -->
          <div
            class="modal"
            id="detailEvent"
            tabindex="-1"
            role="dialog"
            aria-labelledby="myModalLabel"
            aria-hidden="true"
          >
            <div class="modal-dialog modal-lg" role="document" style="max-width: 50%!important;">
              <div class="modal-content padding" style="min-height: 47vh;">
                <div class="modal-header text-center">
                  <h2 class="modal-title w-100 font-weight-bold" style="color:#73818f!important;">
                    Dettaglio Evento
                  </h2>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                   <div class="modal-body mx-12" style="overflow: auto;height: 41vh;padding: 30px;">
                  <div class="md-form mb-12">

               
                  <div class="row">
                  <div class="col-6">
                    <strong class="text-muted font-weight-bold small" style="font-size: 16px">Cliente:</strong><br>
                       <label class="text-muted font-weight-bold small" style="font-size: 14px">{{ ResultDataGetByEvent.user_id }}</label>
                       </div>
                      <div class="col-6"><strong class="text-muted font-weight-bold small" style="font-size: 16px">Data:</strong><br>
                       <label class="text-muted font-weight-bold small" style="font-size: 14px"> {{ ResultDataGetByEvent.date_from }}
                        {{ ResultDataGetByEvent.date_to }}</label></div>
                  </div>
                <div class="row">
                  <div class="col-6">
                    <strong class="text-muted font-weight-bold small" style="font-size: 16px">Descrizione:</strong><br>
                       <label class="text-muted font-weight-bold small" style="font-size: 14px">{{ ResultDataGetByEvent.description }}</label>
                </div>
                <div class="col-6">
                    <strong class="text-muted font-weight-bold small" style="font-size: 16px">Ora:</strong><br>
                       <label class="text-muted font-weight-bold small" style="font-size: 14px">{{ ResultDataGetByEvent.start_time }}
                         {{ ResultDataGetByEvent.end_time }}</label>  
                  </div></div>
                  <div class="row">
                  <div class="col-6">
                  <strong class="text-muted font-weight-bold small" style="font-size: 16px">Servizio:</strong><br>
                       <label class="text-muted font-weight-bold small" style="font-size: 14px">{{ ResultDataGetByEvent.service_id }}</label>  
                  </div>
                  <div class="col-6">
                  <strong class="text-muted font-weight-bold small" style="font-size: 16px">Stato:</strong><br>
                       <label class="text-muted font-weight-bold small" style="font-size: 14px">{{ ResultDataGetByEvent.id_states }}</label> 
                  </div>
                
                  </div>
                  <div class="row">
                  <div class="col-6"> 
                     <strong class="text-muted font-weight-bold small" style="font-size: 16px">Addetto:</strong><br>
                       <label class="text-muted font-weight-bold small" style="font-size: 14px">{{ ResultDataGetByEvent.employee_id }}</label> 
                    </div>
                  <div class="col-6">
                       <label class="text-muted font-weight-bold small" style="font-size: 16px">{{ ResultDataGetByEvent.note }}</label> 
                    </div>
                  </div>
                   <div class="row">
                  <div class="col-6">
                    <strong class="text-muted font-weight-bold small" style="font-size: 16px">Luogo:</strong><br>
                       <label class="text-muted font-weight-bold small" style="font-size: 14px">{{ ResultDataGetByEvent.place_id }}</label> 
                  </div>
                   <div class="col-6">
                    <strong class="text-muted font-weight-bold small" style="font-size: 16px">Nr Posti:</strong><br>
                       <label class="text-muted font-weight-bold small" style="font-size: 14px">{{ ResultDataGetByEvent.nr_place }} Ridotti: {{ ResultDataGetByEvent.reduced_price }} </label> 
                  </div>
                  </div>
                  <div class="row">
                  <div class="col-6">
                    <strong class="text-muted font-weight-bold small" style="font-size: 16px">Prezzo Singolo:</strong><br>
                       <label class="text-muted font-weight-bold small" style="font-size: 14px">{{ ResultDataGetByEvent.price }}</label> 
                    </div>
                     <div class="col-6">
                    <strong class="text-muted font-weight-bold small" style="font-size: 16px">Prezzo Totale:</strong><br>
                       <label class="text-muted font-weight-bold small" style="font-size: 14px">{{ ResultDataGetByEvent.total_price }}</label> 
                    </div>
                  </div>
                   <div class="col-12 text-right">
                        <button
                          type="button"
                          class="btn btn-danger"
                          data-dismiss="modal"
                        ><i class="fa fa-times" aria-hidden="true"></i>
                        Indietro
                        </button>
                       </div>
                </div>
              </div>
            </div>
          </div></div>
          <!-- end popup detailEvent-->

        </div>
          
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BootstrapTable from "@/components/BootstrapTable.vue";
import PageDetail from "@/components/PageDetail.vue";
import Select2 from "@/components/Select2.vue";

import '@fullcalendar/core/vdom' // solves problem with Vite
import FullCalendar, { Calendar } from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import itLocale from "@fullcalendar/core/locales/it";


export default {
  name: "adminCrmAppointments",
  components: {
    BootstrapTable,
    Select2,
    PageDetail,
    FullCalendar
  },

  data: function() {
    return {
      add: dictionaryHelpers.getDictionary("Add"),
      language: dictionaryHelpers.getDictionary("Language"),
      admin: dictionaryHelpers.getDictionary("Admin"),
      cancel: dictionaryHelpers.getDictionary("Cancel"),
      registries: dictionaryHelpers.getDictionary("registries"),
      del: dictionaryHelpers.getDictionary("Delete"),
      deleteCompleted: dictionaryHelpers.getDictionary("DeleteCompleted"),
      DetailEmployeesConfiguration: [],
      detailData: {},
      languages: 0,
      disableButton: true,
      insertCompleted: dictionaryHelpers.getDictionary("InsertCompleted"),
      openDetail: dictionaryHelpers.getDictionary("OpenDetail"),
      save: dictionaryHelpers.getDictionary("Save"),
      defaultLanguageOptions: [],
      BookingAppointmentssMonth: [],
      BookingAppointmentssWeek: [],
      BookingAppointmentssDay: [],
      pageValueSelected: {
      id: 0,
      languagePageSetting: { content: null }
      },
      calendarOptions: {
        plugins: [ dayGridPlugin, interactionPlugin, timeGridPlugin ],
        locale: itLocale,
        initialView: 'dayGridMonth',
        headerToolbar: {
          left: 'prev,next today',
          center: 'title',
          //right: 'dayGridMonth,timeGridWeek,timeGridDay'
          right: 'mese,settimana,giorno'
        },
        customButtons: {
          mese: {
            text: 'Mese',
            click: this.changeMonth,
            right: 'dayGridMonth'   
          },
          settimana: {
            text: 'Settimana',
            click: this.changeWeek, 
            center: 'timeGridWeek' 
          },
          giorno: {
            text: 'Giorno',
            click: this.changeDay,  
            left: 'timeGridDay'    
          },
        }, 
        dateClick: this.handleDateClick,
        eventClick: this.handleEventClick,
        nextDayThreshold: '08:00:00',
        events: [],
        eventColor: '#E5C39F',
        eventTextColor:'#5B5955',
        expandRows: true,
        ProgressiveEventRendering: true,
        eventDisplay: 'auto'
        //events: [{title: 'prova', start: '2021-09-16', end: '2021-09-20 23:59:59'},{title: 'prova 1', start: '2021-09-16', end: '2021-09-18 23:59:59'}]
      },
      configDateTime: {
        format: storageData.sDatePickerFormat(),
        useCurrent: true,
        showClear: true,
        showClose: true,
      },
      TableEmployeesConfiguration: [],
      tableCustomerResult: [],
      ResultDataGetAll: [],
      ResultDataGetByEvent: [],
      ResultDataGetByEventNote: [],
      tableData: [],
      tableResult: [],
      titleDetail: null,
      updateCompleted: dictionaryHelpers.getDictionary("UpdateCompleted"),
      url: window.location.pathname,
      rowIdSelected: 0,
      rowsSelected: 0
    };
  },
  created() {
    var adminCrmAppointments = this;
    
    spinnerHelpers.show();
    this.languages = storageData.sIdLanguage();

    adminCrmAppointments.defaultLanguageOptions = {
      id: storageData.sIdLanguage(),
      text: storageData.sDescriptionLanguage()
    };

      adminCrmAppointments.loadTable();
      adminCrmAppointments.allEvents();
  },
  methods: {
    changeMonth: function(event) {
      var adminCrmAppointments = this;
      adminCrmAppointments.calendarOptions.initialView = 'dayGridMonth';
      this.$refs.calendar.getApi().changeView('dayGridMonth');
       console.log(this.$refs);
      adminCrmAppointments.calendarOptions.events = adminCrmAppointments.BookingAppointmentssMonth;
    },
    changeWeek: function(event) {
      var adminCrmAppointments = this;
      adminCrmAppointments.calendarOptions.initialView = 'timeGridWeek';
      this.$refs.calendar.getApi().changeView('timeGridWeek');
      adminCrmAppointments.calendarOptions.events = adminCrmAppointments.BookingAppointmentssWeek;
    },
    changeDay: function(event) {
      var adminCrmAppointments = this;
      adminCrmAppointments.calendarOptions.initialView = 'timeGridDay';
      this.$refs.calendar.getApi().changeView('timeGridDay');
     
      adminCrmAppointments.calendarOptions.events = adminCrmAppointments.BookingAppointmentssDay;
    },
    loadTable(ln) {
      var adminCrmAppointments = this;
      if(!functionHelpers.isValued(ln)){
        ln = storageData.sIdLanguage();
      }else{
        ln = this.languages;
      }
      appointmentsServices.getAll(ln,function(result) {
        adminCrmAppointments.ResultDataGetAll = result.data;
         spinnerHelpers.hide();
      });
       $("#appointments").addClass("active");
       $("#tablelist").removeClass("active");
    },


      handleDateClick: function(arg) {
       // console.log(arg);
          //console.log(arg);
         // alert('date click! ' + arg.dateStr)
      },

      handleEventClick: function(arg) {
       var adminCrmAppointments = this;
       var idRow = arg.event.id;
         appointmentsServices.getByIdEvent(idRow,function(result) {
            adminCrmAppointments.ResultDataGetByEvent= result.data;

         spinnerHelpers.hide();
      });
         $("#detailEvent").modal("show");
    },

     onClickDetailPopup: function(id) {
       var adminCrmAppointments = this;
       var idRow = id;
         appointmentsServices.getByIdEvent(idRow,function(result) {
            adminCrmAppointments.ResultDataGetByEvent= result.data;
         spinnerHelpers.hide();
      });
         $("#detailEvent").modal("show");
    },


      allEvents() {
        var ln = storageData.sIdLanguage();
        var adminCrmAppointments = this;
        appointmentsServices.getAllResultCalendar(ln,function(result) {
          adminCrmAppointments.calendarOptions.events = result.data[0].BookingAppointmentssMonth;

          adminCrmAppointments.BookingAppointmentssMonth = result.data[0].BookingAppointmentssMonth;
          adminCrmAppointments.BookingAppointmentssWeek = result.data[0].BookingAppointmentssWeek;
          adminCrmAppointments.BookingAppointmentssDay = result.data[0].BookingAppointmentssDay;          
        });
      },

     languageChange(value) {
      spinnerHelpers.show();
      var adminCrmAppointments = this;
      this.languages = value;
      adminCrmAppointments.loadTable(value);
      spinnerHelpers.hide();
    },


    ontabtable(ln){
      var adminCrmAppointments = this;
      $("#tablelist").addClass("active");
      $("#appointments").removeClass("active");

      if(!functionHelpers.isValued(ln)){
        ln = storageData.sIdLanguage();
      }else{
        ln = this.languages;
      }
      appointmentsServices.getAll(ln,function(result) {
        adminCrmAppointments.ResultDataGetAll = result.data;
        spinnerHelpers.hide();
      });
    },

     ontabappointments(){
      var adminCrmAppointments = this;
      $("#appointments").addClass("active");
      $("#tablelist").removeClass("active");
    },


    confirmSearchForPlace(){
      spinnerHelpers.show();
      var adminCrmAppointments = this;
      var ln = adminCrmAppointments.languages;

       var data = {
          place_id: $("#place_id_search").val(),
          service_id: $("#service_id_search").val(),
          employee_id: $("#employee_id_search").val(),
          id_states: $("#id_states_search").val(),
          date_from: $("#date_from").val(),
          date_to: $("#date_to").val()
       };
        appointmentsServices.getAllAppointmentsSearch(data, function (result) {
        adminCrmAppointments.ResultDataGetAll = result.data;
        spinnerHelpers.hide();
      });
    },

  }
};
</script>
<style>
.card-title-admin h1{
  font-size:40px;
  font-weight: lighter;
  color:#303C54;
}
.align-btn {
    position: absolute;
    margin-top: 11px;
    z-index: 1;
}

.classinput {
    min-height: 56px;
    font-size: 15px;
}

/* end translate */
.nav-tabs .nav-item {
  width: 50%;
}
.nav-tabs .nav-link {
  width: 100%;
  border-radius: 0;
  color: #fff;
  background: #3c4b64;
  border-bottom: 3px solid #f45f00 !important;
  border: 0px;
}
.nav-tabs .nav-link.active {
  background: #2a3545 !important;
}
.nav-tabs > .nav-item > .nav-link:not(.active) {
  background: #3c4b64 !important;
}

.fc-daygrid-block-event .fc-event-title {
    padding: 1px!important;
    font-size: 12px!important;
    font-family: Avenir, Helvetica, Arial, sans-serif!important;
}

.fc-h-event .fc-event-main-frame {
    display: inline!important;
}
.fc-direction-ltr .fc-daygrid-event.fc-event-start, .fc-direction-rtl .fc-daygrid-event.fc-event-end {
    margin-top: 13px;
    padding: 1px!important;
    font-size: 12px!important;
    font-family: Avenir, Helvetica, Arial, sans-serif!important;
}

</style>